import theme from '@/theme';
import styled from '@emotion/styled';
import { Dialog } from '@mui/material';

export const StyledDialog = styled(Dialog)`
    .MuiDialog-paper {
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        width: 464px;
        padding: 24px;
        font-family: 'Manrope', sans-serif;
        color: ${theme.colors.black[800]};
        gap: 16px;
    }
`;
